module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isSubmitButtonLoading": _vm.isSubmitting,
      "customWidth": '650px',
      "noMarginOnButton": true,
      "appendToBody": _vm.appendToBody,
      "isShowConfirmDeleteMessage": false
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      },
      "confirm": _vm.onConfirmDelete
    }
  }, [_c('div', {
    attrs: {
      "slot": "custom_warning"
    },
    slot: "custom_warning"
  }, [_c('div', {
    staticClass: "away_warning"
  }, [(_vm.uncancelGroups.length > 0) ? _c('div', {
    staticClass: "away_warning__lessons"
  }, [_c('strong', [_vm._v(_vm._s(_vm.i18n.lessons_will_be_restored))]), _vm._v(" "), _vm._l((_vm.uncancelGroups), function(grp) {
    return _c('div', {
      key: 'u_' + grp.name
    }, [_c('table', {
      staticClass: "away_warning__lessons__table"
    }, [_c('tbody', _vm._l((grp.events), function(ev) {
      return _c('tr', {
        key: ev.event_id + '_' + grp.name,
        staticClass: "marg-0-5-top"
      }, [_c('td', [_vm._v("\n                " + _vm._s(grp.name) + " | " + _vm._s(ev.title) + "\n                "), _c('span', {
        staticClass: "text-gray"
      }, [_vm._v("(" + _vm._s(_vm.humanTime(ev.start, ev.end)) + ")")])])])
    }), 0)])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "away_warning__text"
  }, [_c('h4', {
    staticClass: "marg-0-bottom"
  }, [_vm._v(_vm._s(_vm.i18n.confirm_delete_title))]), _vm._v(" "), _c('p', {
    staticClass: "pad-1 italic"
  }, [_vm._v(_vm._s(_vm.i18n.confirm_delete_text))]), _vm._v(" "), (_vm.uncancelGroups.length === 0) ? _c('p', {
    staticClass: "pad-1 italic pad-0-top"
  }, [_vm._v("\n          " + _vm._s(_vm.i18n.no_lessons_to_restore) + "\n        ")]) : _vm._e()])])]), _vm._v(" "), _c('p', {
    attrs: {
      "slot": "confirmText"
    },
    slot: "confirmText"
  }, [_vm._v(_vm._s(_vm.i18n.delete))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66c7628e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/DModalDeleteAwayEvent.vue
// module id = 1970
// module chunks = 1